/* 调用app日历 添加行程的通用方法 */
import betterwe from '@/common/app-common.js'
import dataObj from '@/common/date.js'
import { Toast } from 'vant'
let windowMethdId = 0
//根据字符串获取时间 index：距离今天的天数   duration:行程时间 单位分钟
const toTimeStr = function (str, duration = 0) {
  if (duration == 0) {
    return str
  } else {
    let times = new Date(str).getTime()
    times = times + duration * 1000 * 60
    return dataObj.getFullTimeStr(times)
  }
}
const getTimeArr = function (list, munute) {
  let res = []
  list.map((item) => {
    let obj = {
      startTime: toTimeStr(item, 0),
      endTime: toTimeStr(item, munute)
    }
    res.push(obj)
  })
  return res
}
class Calendar {
  constructor(options) {
    this.lowestVersion = 59
    this.iosCalendarName = 'iCloud'
    this.calendarName = options.calendarName
    this.calendarAccountName = options.calendarAccountName || 'betterWE星球'
  }
  //是否允许显示日历 app版本低于59则不显示
  async allowCalendar() {
    return new Promise((resolve, reject) => {
      betterwe
        .getAppDevicesInfo()
        .then((res) => {
          if (res.clientversion >= this.lowestVersion) {
            resolve(true)
          }
          resolve(false)
        })
        .catch((err) => {
          resolve(false)
        })
    })
  }
  //设置日历事件id 只设置不更新
  setCalendarEvent(id, data) {
    if (id) {
      return new Promise((resolve, reject) => {
        let timeStr =
          'createOrUpdateCalendarEventResponseMethod' + windowMethdId++
        window[timeStr] = (res) => {
          console.log('设置日历', res)
          res = JSON.parse(res)
          if (res.code == 0) {
            resolve(res)
          } else {
            reject(res)
          }
          window[timeStr] = null
        }
        let accountName = this.calendarName
        betterwe
          .getAppDevicesInfo()
          .then((res) => {
            if (res.clientplatform == 2) {
              accountName = this.iosCalendarName
            }
            window.calendarChannelMethod.postMessage(
              JSON.stringify({
                callbackMethod: timeStr,
                methodType: 'createOrUpdateCalendarEvent',
                params: JSON.stringify({
                  calendarAccountName: accountName, //日历账户本地手机的名字 可不传 默认app的名字
                  calendarId: id, //日历的id , 如果没有这个日历账户 则会自动新增日历账户 如果有,则往这个日历账户中添加
                  calendarName: this.calendarName, //日历账户的名字 建议传 按照功能模块来命名 比如说喝水提醒 默认app的名字
                  eventId: '', //事件id,没有此事件会创建事件，如果有就更新事件
                  description: this.calendarName, //事件的描述
                  eventTitle: this.calendarName, //事件的title
                  url: '', //事件的url
                  allDay: 0, //是否是全天时间 0否 1是 默认0
                  availability: 2, //暂无作用 默认2
                  recurrenceInterval: 1, //提醒的间隔时间
                  recurrenceMethod: '', //提醒的间隔方式 1: 天 2:周 3:月 4:年
                  remindersTimeMinutes: 5, //事件出发前几分钟提醒
                  startTime: data.startTime, //事件的开始时间
                  endTime: data.endTime //事件的结束时间}),
                })
              })
            )
          })
          .catch(() => {})
      })
    } else {
      return Promise.reject({ message: 'id不能为空' })
    }
  }
  setCalendarEvents(id, list) {
    if (Array.isArray(list) && list.length) {
      let arr = []
      for (let i = 0; i < list.length; i++) {
        arr.push(this.setCalendarEvent(id, list[i]))
      }
      return Promise.all(arr)
    } else {
      return Promise.reject()
    }
  }
  //删除日历事件
  deleteCalendarEvent(id, eventId) {
    let callbackName = 'deleteCalendarEventResponse' + windowMethdId++
    window[callbackName] = () => {}
    window.calendarChannelMethod.postMessage(
      JSON.stringify({
        callbackMethod: callbackName,
        methodType: 'deleteCalendarEvent',
        params: JSON.stringify({
          calendarId: id,
          eventId: eventId
        })
      })
    )
  }
  //设置日历 返回日历的id
  setCalendar(values) {
    return new Promise((resolve, reject) => {
      let methodName = 'calendarResponseMethod' + windowMethdId++
      window[methodName] = (res) => {
        let setRes = JSON.parse(res)
        if (setRes.code == 0) {
          this.setCalendarEvents(setRes.calendarId, values)
            .then((res) => {
              resolve(setRes)
            })
            .catch((res) => {
              reject(res)
            })
        } else {
          reject(setRes)
        }
        window[methodName] = null
      }
      betterwe
        .getAppDevicesInfo()
        .then((res) => {
          let accountName = this.calendarAccountName
          if (res.clientplatform == 2) {
            accountName = this.iosCalendarName
          }
          window.calendarChannelMethod.postMessage(
            JSON.stringify({
              callbackMethod: methodName,
              methodType: 'createCalendar',
              params: JSON.stringify({
                calendarName: this.calendarName,
                calendarAccountName: accountName
              })
            })
          )
        })
        .catch(() => {})
    })
  }
  //根据id查找是否有这个日历
  hasCalendar(id) {
    let methodName = 'isCalendarsResponseMethod' + windowMethdId++
    return new Promise(function (resolve, reject) {
      window[methodName] = (res) => {
        res = JSON.parse(res)
        if (res.code == 0) {
          resolve(res)
        } else {
          reject(res)
        }
        window[methodName] = null
      }
      window.calendarChannelMethod.postMessage(
        JSON.stringify({
          callbackMethod: methodName,
          methodType: 'isCalendars',
          params: JSON.stringify({
            calendarId: id
          })
        })
      )
    })
  }
  //删除日历
  delCalendar() {
    return new Promise(async (resolve, reject) => {
      let res = await this.getCalendarList().catch((e) => {
        reject(e)
      })
      if (res && res.data) {
        let list = res.data || []
        let calendarIdList = []
        list.map((item) => {
          if (item.name == this.calendarName) {
            calendarIdList.push(item.id)
          }
        })
        let promiseArr = []
        calendarIdList.map((item) => {
          promiseArr.push(
            new Promise((resolve1, reject1) => {
              let methodName = 'deleteCalendarResponse' + windowMethdId++
              window[methodName] = (res) => {
                try {
                  res = JSON.parse(res)
                  if (res.code == 0) {
                    resolve1(res)
                  } else {
                    reject1(res)
                  }
                } catch (error) {
                  reject1()
                }
                window[methodName] = null
              }
              window.calendarChannelMethod.postMessage(
                JSON.stringify({
                  callbackMethod: methodName,
                  methodType: 'deleteCalendar',
                  params: JSON.stringify({
                    calendarId: item
                  })
                })
              )
            })
          )
        })
        Promise.all(promiseArr)
          .then(() => {
            resolve()
          })
          .catch(() => {
            reject()
          })
      } else {
        reject()
      }
    })
  }
  getCalendarList() {
    return new Promise(function (resolve, reject) {
      let methodName = 'getCalendarListResponse' + windowMethdId++
      window[methodName] = (res) => {
        try {
          res = JSON.parse(res)
          if (res.code == 0) {
            resolve(res)
          } else {
            reject(res)
          }
        } catch (error) {
          reject(error)
        }
        window[methodName] = null
      }
      window.calendarChannelMethod.postMessage(
        JSON.stringify({
          callbackMethod: methodName,
          methodType: 'getCalendarList',
          params: JSON.stringify({})
        })
      )
    })
  }
  /* 设置日历   timeList:需要设置的行程时间，munute: */
  bindSetCalendar(timeList, munute = 5) {
    let timeArr = getTimeArr(timeList, munute)
    return new Promise((resolve, reject) => {
      this.setCalendar(timeArr)
        .then((res) => {
          resolve(res)
        })
        .catch((res) => {
          reject(res)
        })
    })
  }
  //根据名字查找是否有这个日历
  haveCalendar(calendarName) {
    return new Promise(async (resolve, reject) => {
      let res = await this.getCalendarList().catch((e) => {
        reject(e)
      })
      if (res && res.data) {
        let list = res.data
        if (list && Array.isArray(list)) {
          for (let i = 0; i < list.length; i++) {
            if (list[i].name == calendarName) {
              resolve(true)
              break
            }
          }
        }
        resolve(false)
      }
      reject()
    })
  }
}
export { Calendar }
